export const ButtonColors = {
  orange: 'orange',
  green: 'green',
  blue: 'blue',
  grey: 'grey',
  darkGrey: 'dark-grey',
};
